import React, { useState, useEffect } from "react";
import { InputLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "../styles/pages/TemplateManager.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
const iconComponent = (props) => {
  return <ExpandMoreIcon className={props.className} />;
};

const DropdownWithLabelSizeTemplate = (props) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setOptions(props.options);
  }, [props]);

  const getValue = () => {
    if (
      options &&
      options.items &&
      options.items.length > 0 &&
      options.value &&
      options.items.indexOf(options.value) !== -1
    ) {
      return options.value;
    }
    return "";
  };

  return (
    <FormControl
      className="tempInputField select-with-padding "
      variant="standard"
      fullWidth={true}
    >
      <InputLabel htmlFor={options.label} d="demo-simple-select-standard-label">
        {options.label}
      </InputLabel>
      <Select
        labelId="demo-simple-select-standard-label"
        value={getValue()}
        onOpen={options.onOpen}
        onChange={options.handleChange}
        disabled={options.disabled}
        label={options.label}
        name={options.name}
        id={options.name}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          PaperProps: {
            style: {
              maxWidth: props.menuWidth,
            },
          },
          getContentAnchorEl: null,
        }}
        IconComponent={iconComponent}
      >
        {options.items &&
          options.items.length > 0 &&
          options.items.map((item) => {
            return (
              <MenuItem
                value={item}
                id={item}
                key={item}
                className={`menu-items ${
                  item === props.options.value
                    ? "blue-background"
                    : "no-blue-background"
                }`}
                style={{ paddingRight: "10px" }}
              >
                {item}{" "}
                {props.tick?.some(
                  (animation) =>
                    animation !== undefined && animation.animationType === item
                ) ? (
                  <CheckIcon style={{ color: "#00b10a", fontSize: 15 }} />
                ) : (
                  ""
                )}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
};

export default DropdownWithLabelSizeTemplate;
